export default "/images/github.svg?e7ab8675a2cbadea548cafe724065b9e";